exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size[data-v-7976821c]{font-size:35px !important}\n", ""]);

// exports
